import React from 'react';
import { ListTodo } from 'lucide-react';
import CallbacksPanel from './CallbacksPanel';
// v3 (2026-09-22): the tab's own scope; the list rows are shared with idle.
import '../../styles/task-v3.css';

// Task tab — the backlog workspace. Scheduled callbacks live here (they ARE
// tasks); an accepted task contact seizes the centre panel like any contact.
export default function TaskPanel() {
  return (
    <main className="centre-panel task-panel task-v3-screen">
      <div className="tab-header">
        <span className="tab-header-icon"><ListTodo size={16} /></span>
        <div>
          <h2 className="tab-header-title">Task queue</h2>
          <p className="tab-header-sub">Scheduled callbacks and follow-ups for your queue.</p>
        </div>
      </div>
      <CallbacksPanel />
    </main>
  );
}
